import { render, staticRenderFns } from "./ClaimPools.vue?vue&type=template&id=0eeea7ba&"
import script from "./ClaimPools.vue?vue&type=script&lang=js&"
export * from "./ClaimPools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports